import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, finalize } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/UserService';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  user: User;

  constructor(private cookieService: CookieService,
    public rest: UserService,
    private router: Router) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    console.log("The url is: " + state.url);

    //check if user is in sessionStorage
    const sessionUser = sessionStorage.getItem("user");
    if (sessionUser !== null) {
      console.log("AuthGuard checking the user: " + sessionUser);
      let theUser: User = JSON.parse(sessionUser);
      if (theUser.accountStatus && theUser.accountStatus.startsWith("bss.api.error")) {
        console.log("AuthGuard find user locked, redirect to public/error");
        this.router.navigate(['public/error']);
        return false;
      }
      
      return true;
    }

    //if not, call rest service to get user and store it into the session
    this.user = new User();
    const resultSubject = new Subject<boolean>();
    
    this.rest.getUserInfo(this.user).subscribe(
      (response) => {
        console.log("AuthGuard - response" + JSON.stringify(response));
        sessionStorage.setItem("user", JSON.stringify(response));
        
        console.log("AuthGuard - session set - " + sessionStorage.getItem("user"));

        const theUser = JSON.parse(sessionStorage.getItem("user"));
        const prefLang = theUser.preferredLanguage ? theUser.preferredLanguage.trim().toLowerCase() : '';
        const currentLang = (prefLang.startsWith('fr')) ? 'fr' : 'en';
        sessionStorage.setItem("currentLang", currentLang);

        resultSubject.next(true);
        resultSubject.complete();
      }, (error) => {
        resultSubject.next(false);
        resultSubject.complete();
        this.router.navigate(['public/error']);
      });

    return resultSubject.asObservable();
  }
}